import { mapGetters } from 'vuex';
import mvtCollapse from '@/common/components/mvtcollapse/mvt-collapse.vue';

export default {
    name: 'propertyFeatureNew',
    inject: ['$eventBus'],
    props: {
        showCTA: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    components: {
        mvtCollapse,
    },
    data() {
        return {
            orginalCollapse: false,
            show: false,
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        ...mapGetters('dpp', ['dpp']),
        zumperIconLink() {
            return 'https://www.zumper.com/favicon.ico';
        },
        getFeatures() {
            let features = [];
            if (!this.dpp.features || this.dpp.features.length === 0) {
                return features;
            }
            features = this.dpp.features.map((feature, index) => {
                let group = [
                    {
                        name: feature.name,
                    },
                ];
                if (index === 0) {
                    if (this.dpp.fCooling) {
                        group.push({
                            name: this.molang('dpp.propertyDetails.cooling'),
                            value: this.dpp.fCooling,
                        });
                    }
                    if (this.dpp.fHeating) {
                        group.push({
                            name: this.molang('dpp.propertyDetails.heating'),
                            value: this.dpp.fHeating,
                        });
                    }
                    if (this.dpp.fLevels) {
                        group.push({
                            name: this.molang('dpp.propertyDetails.levels'),
                            value: this.dpp.fLevels,
                        });
                    }
                }
                group = group.concat(feature.value.flatMap((e) => e.value));
                return group;
            });
            return features;
        },
    },
    methods: {
        toggle() {
            this.show = !this.show;
        },
        pop3d(url) {
            this.$eventBus.$emit('property-pop-3d', url);
        },
        openAssignedAgentHotlead(options) {
            let buttonText = options.cta;
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.$options.name,
                opt: {
                    hotleadType: 'PropertyDetailsDPP',
                    propertyId: this.dpp.propertyId,
                    noSecondaryLead: true,
                    propertyData: this.dpp,
                    buttonText: buttonText,
                    hotleadTitle: 'Connect with an agent',
                    showComment: false,
                    hideVeteran: true,
                },
            });
            this.$eventBus.$emit('ga', { ec: 'dppsectionscta', en: 'click', el: options.section, props: { link_name: buttonText } });
        },
        isValidURL(str) {
            return /^(https?:\/\/|\/\/|www\.)/i.test(str);
        },
    },
};
